import { render } from "./DialogContenutoSicurezza.vue?vue&type=template&id=448b307c"
import script from "./DialogContenutoSicurezza.vue?vue&type=script&lang=js"
export * from "./DialogContenutoSicurezza.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__